// extracted by mini-css-extract-plugin
export default {"container":"ZZqLXS","list":"Tn4g5r","event":"nJOvU6","oldTitle":"lhJYhg","chevron":"nth3Rs","info":"DuCOC5","time":"KOi6Xx","revamp":"HFzGwL","title":"JsVhwR"};